import { render, staticRenderFns } from "./ImagePreviewModal.vue?vue&type=template&id=6dda64dd&scoped=true"
import script from "./ImagePreviewModal.vue?vue&type=script&lang=ts"
export * from "./ImagePreviewModal.vue?vue&type=script&lang=ts"
import style0 from "./ImagePreviewModal.vue?vue&type=style&index=0&id=6dda64dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda64dd",
  null
  
)

export default component.exports